import React from 'react'
import styled from 'react-emotion'
import Link from 'gatsby-link'
import { mediumMediaQuery } from 'utils/style-helpers'
import Wrapper from 'components/Wrapper'
import SocialMedia from './SocialMedia'
import Info from './Info'

const ContentWrapper = styled(Wrapper)`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-bottom: -20px;

  ${mediumMediaQuery} {
    justify-content: space-between;
    margin-bottom: 0;
  }
`

const Main = styled.div`
  background: #424242;
  padding: 44px 0;
`

const BackToTop = styled.div`
  background: #212121;
  padding: 15px 0;
  color: #4CAF50;
  font-size: 13px;
  text-align: right;

  a {
    color: inherit;
    text-decoration: none;
  }
`

const Footer = () => (
  <div>
    <Main>
      <ContentWrapper>
        <Info />
        <SocialMedia />
      </ContentWrapper>
    </Main>
    <BackToTop>
      <Wrapper>
        <Link onClick={() => window.scrollTo(0, 0)} to="#">Back To Top</Link>
      </Wrapper>
    </BackToTop>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js